import React, { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { AppView, Button, StatusBar, withAnimatedNavigationHeader, } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { getFilterPreview } from 'actions';
import TransactionsPreview from '../../transactions/components/TransactionsPreview';
import { isIOS } from '../../../constants';
const strings = {
    title: 'Pick a transaction to copy its reference',
    shortTitle: 'Pick a transaction to copy',
    subtitle: 'You will still be able to edit the reference later',
};
const SmartRuleSelectTransactionScreen = withAnimatedNavigationHeader(({ navigation, route, scrollHandler }) => {
    const [selected, setSelected] = useState();
    const query = useMemo(() => ({
        accountIds: `[${route.params.selectedAccounts.join(',')}]`,
    }), [route.params.selectedAccounts]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(false, true);
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            ...(isIOS && {
                headerLeft: () => (<NavigationCloseButton onPress={() => navigation.pop()}/>),
            }),
        });
    }, []);
    const handleContinue = useCallback(() => {
        if (!selected)
            return;
        route.params.onSelect(selected.realCounterpartName);
        navigation.goBack();
    }, [route.params, selected]);
    const ListHeaderComponent = useMemo(() => (<ScreenInfoHeader title={strings.title} subTitle={strings.subtitle}/>), []);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <TransactionsPreview onScroll={scrollHandler} contentContainerStyle={paddingBottom} ListHeaderComponent={ListHeaderComponent} query={query} onSelect={setSelected} isEditingTransactions isMultipleSelect={false} selected={selected} endpoint={getFilterPreview} initialTransactions={route.params.initialTransactions}/>
          <Button brand isInIOS13Modal floating title="Copy transaction reference" disabled={!selected} onPress={handleContinue}/>
        </AppView>);
}, ({ colors }) => ({
    title: strings.shortTitle,
    hideTitleOnScroll: true,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
    isIOS13NativeModal: true,
}));
export default SmartRuleSelectTransactionScreen;
